module.exports = __webpack_public_path__ + "img/icon_2.f7812a3e.png";